import { resolveApiAssetUrl } from '../../../platform/api/asset-url'

export function safeStoryPath(value: string): string | null {
  if (value.length > 2048 || !value.startsWith('/')) return null
  try {
    let decoded = value
    for (let i = 0; i < 3; i += 1) {
      if (
        decoded.startsWith('//') ||
        decoded.includes('\\') ||
        /\p{Cc}/u.test(decoded)
      )
        return null
      const next = decodeURIComponent(decoded)
      if (next === decoded) break
      decoded = next
    }
    if (
      decoded.startsWith('//') ||
      decoded.includes('\\') ||
      /\p{Cc}/u.test(decoded) ||
      /%(?:2f|5c|0[\da-f]|1[\da-f]|7f)/i.test(decoded)
    )
      return null
    const url = new URL(value, 'https://cardreplay.invalid')
    return url.origin === 'https://cardreplay.invalid' ? value : null
  } catch {
    return null
  }
}

export function storyImageUrl(value: string | null): string | null {
  if (!value) return null
  if (/^https:\/\//i.test(value)) {
    try {
      const url = new URL(value)
      return url.username || url.password ? null : url.href
    } catch {
      return null
    }
  }
  return /^\/(?:storage\/)?images\/[\w.-]+$/.test(value)
    ? resolveApiAssetUrl(value, { normalizeLegacyImagePath: true })
    : null
}
